import React, { type KeyboardEventHandler, useState } from "react";

import { TextInput } from "@shared/text-input";

export function SimpleNotificationsContainer({
  notificationName,
  notificationEmails,
  onAddEmail,
  onRemoveEmail,
}: {
  notificationName: string;
  notificationEmails: string[];
  onAddEmail: (email: string) => void;
  onRemoveEmail: (email: string) => void;
}) {
  const [newEmailField, setNewEmailField] = useState<string>("");

  // Note: Handling adding email with "Enter" key to be consistent with how
  // ../notifications.tsx currently works
  const handleKeyDown: KeyboardEventHandler<HTMLInputElement> = (event) => {
    if (event.key === "Enter") {
      onAddEmail(newEmailField);
      setNewEmailField("");
    }
  };

  // Note: this is styled to be identical to ../notifications.tsx which
  // should be changed because it's not good
  return (
    <div>
      <h3 className="mt-4">
        <b>{notificationName}</b>
      </h3>
      <ul>
        {notificationEmails.map((email) => (
          <li key={email}>
            {email}{" "}
            <i
              aria-label="Delete email"
              className="fa-regular fa-sharp fa-times"
              style={{ color: "red", cursor: "pointer" }}
              onClick={() => onRemoveEmail(email)}
            />
          </li>
        ))}
      </ul>
      <TextInput
        label="Add a new email"
        value={newEmailField}
        placeholder="Email"
        onChange={({ target }) => setNewEmailField(target.value)}
        onKeyDown={handleKeyDown}
      />
    </div>
  );
}
